import type { ReactNode } from "react";
import { cn } from "@utils/cn.ts";
import { RosterGridType } from "./roster-grid-type";

type RosterGridProps = {
  type?: "ROSTER_CREATE" | "ROSTER_ONLY_VIEW";
  className?: string;
  children: ReactNode;
  hasPrevTail?: boolean;
  gridType?: RosterGridType;
};

export default function RosterGrid({
  className,
  children,
  gridType,
  type,
  hasPrevTail,
}: RosterGridProps) {
  return (
    <div
      className={cn(
        "flex [&>*:first-child]:flex-shrink-0 gap-3.5",
        gridType === RosterGridType.BODY && "[&>*:first-child]:w-[310px]",
        gridType === RosterGridType.HEADER && "[&>*:first-child]:w-[230px]",

        gridType === RosterGridType.HEADER &&
          hasPrevTail &&
          "[&>*:first-child]:w-[435px]",
        className
      )}
    >
      {children}
    </div>
  );
}
